function CanchaForm({ form, onChange, onSubmit, canchas = [] }) {
  return (
    <article className="panel">
      <h2>Nueva cancha</h2>
      <form className="form-grid" onSubmit={onSubmit}>
        
        <label>
          <input
            name="nombre"
            value={form.nombre}
            onChange={onChange}
            placeholder="Nombre de cancha"
            required
          />
        </label>

        <label>
          <input
            type="number"
            name="valorHora"
            min="1"
            step="0.01"
            value={form.valorHora}
            onChange={onChange}
            placeholder="Valor por hora"
            required
          />
        </label>

        {/* ✅ NUEVO: checkbox subcancha */}
        <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <input
            type="checkbox"
            name="esSubcancha"
            checked={form.esSubcancha || false}
            onChange={(e) =>
              onChange({
                target: {
                  name: "esSubcancha",
                  value: e.target.checked,
                },
              })
            }
          />
          Es subcancha (anidada)
        </label>

        {/* ✅ NUEVO: selector de cancha padre */}
        {form.esSubcancha && (
          <label>
            <select
              name="parentCanchaId"
              value={form.parentCanchaId || ""}
              onChange={onChange}
              required
            >
              <option value="">Seleccionar cancha principal</option>
              {canchas.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.nombre}
                </option>
              ))}
            </select>
          </label>
        )}

        <button type="submit">Guardar cancha</button>
      </form>
    </article>
  );
}

export default CanchaForm;